import type { FormValues } from "@/widgets/classic-form/form";
import { getEventInstancesPath } from "@/entities/data-model";
import type { EventFieldsGroup, EventFieldset } from "@/entities/form-metadata";
import { EventAssertion } from "@/entities/form-metadata";
import type { FieldPath } from "@/shared/forms";

const FOCUS_PATH_BY_ASSERTION: Record<EventAssertion, string> = {
    [EventAssertion.Day]: "date.day",
    [EventAssertion.Month]: "date.month",
    [EventAssertion.Year]: "date.year",
    [EventAssertion.Place]: "location",
};

// Focus follows the field, not the row: on a mixed row the year input is bound under its own
// field's identity, which need not be the row's primary one.
export const resolveAddRowFocusTarget = (
    fieldset: Pick<EventFieldset, "fields">,
    assertions: EventFieldsGroup["assertions"],
): { instancesPath: FieldPath<FormValues>; mappedAssertion: string } | undefined => {
    const priorityField = assertions
        .map(({ assertion }) => fieldset.fields.find((field) => field.assertion === assertion))
        .find(Boolean);
    if (!priorityField) return undefined;

    return {
        instancesPath: getEventInstancesPath(priorityField) as FieldPath<FormValues>,
        mappedAssertion: FOCUS_PATH_BY_ASSERTION[priorityField.assertion],
    };
};
